import api from "PFCore/api";
import { Id } from "PFTypes";

export type TagPayload = {
  customValueId?: Id;
  note?: string;
  notificationRecipientIds?: Id[];
};

export const addOrUpdateTag = (activityId, tagPayload: TagPayload) =>
  api({
    url: `activities/${activityId}/tags`,
    method: "POST",
    data: tagPayload
  });

export const removeTag = (activityId: Id, notificationRecipientIds?: Id[]) =>
  api({
    url: `activities/${activityId}/tags`,
    method: "DELETE",
    data: { notificationRecipientIds }
  });
